import React from 'react';
import PropTypes from 'prop-types';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div>HEllo not asas</div>
        );
    }
}

App.propTypes = {};

export default App;
